import React from 'react'
import { Job, JobWizardMobile } from 'sprockets_react/job_wizards/registries'

JobWizardMobile.CloseModalWarning = function(props) {
  return (
    <div className="close-modal-warning" style={{display: 'none'}}>
      <div className="pt72">
        <h3 className="bold text-copy-2 pb20">{Job.Data.id ? 'Are you sure you want to close?' : 'Are you sure you want to exit?'}</h3>
        <div className="row">
          <div className="col-xs-12 pb20">
            <a href="#" className="btn btn-block btn-clear font-12 radius-6 modal-stay">
              { Job.Data.id && !Job.Data.lastSlide ? 'Let me add more info first' : 'Stay & Continue' }
            </a>
          </div>
          <div className="col-xs-12">
            <a href="#" className="btn btn-red btn-block font-12 radius-6 modal-exit text-white btn-red" style={{'backgroundColor': 'red !important'}}>
              { Job.Data.id && !Job.Data.lastSlide ? 'Invite Businesses Now' : 'Exit' }
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
